import { freshAdviserListApi } from "@/libs/api.js";
// import { uleUrl, uleCdn, getCookie } from "@/libs/common";
// import bottomPop from "@/components/yzg/bottomPop.vue";
export default {
  name: "customerSee",
  data() {
    return {
      title: "顾客浏览接龙统计",
      navList: [
        {
          name: "按访客量",
          id: 2,
        },
        {
          name: "按销售额",
          id: 1,
        },
      ],
      currentId: 2,
      loading: false,
      finished: false,
      finishedText: "加载中...",
      isLoad: false,
      defaultAvatar: "https://pic.ulecdn.com/itempic_188x188.GIF",
      list: [],
      listStatus: 0,
      query: {
        type: 7,
        freshType: 1,
        orderType: 2,
        clientCallType: "H5",
        pageIndex: 1,
        pageSize: 10,
      },
    };
  },

  mounted() {
    console.log(this.$route.query);
    this.$route.query.type == 1 ? (this.title = "顾客浏览接龙统计") : (this.title = "顾客浏览商品统计");
    this.query.freshType = this.$route.query.type;
    this.getFreshAdviserList();
  },
  methods: {
    // 店铺列表
    getFreshAdviserList() {
      this.$toast.loading({
        duration: 0,
        mask: true,
        message: "加载中...",
      });
      freshAdviserListApi(this.query).then((res) => {
        this.$toast.clear();
        this.loading = false;
        this.finished = false;
        if (res.returnCode == "0000" && res.data && res.data.freshAdviserListRess) {
          this.list = this.list.concat(res.data.freshAdviserListRess);
          this.list.length > 0 ? (this.listStatus = 1) : (this.listStatus = 2);
          if (this.query.pageIndex == res.data.totalPage) {
            this.finished = true;
            this.finishedText = "我已到达底部, 暂无其他数据啦~~";
          } else {
            this.finished = false;
            this.query.pageIndex++;
          }
        } else {
          this.listStatus = 2;
          this.finished = true;
        }
      });
    },
    handleChangeNav(item) {
      this.currentId = item.id;
      this.list = [];
      this.listStatus = 0;
      this.query.pageIndex = 1;
      this.query.orderType = item.id;
      this.getFreshAdviserList();
    },
  },
};
